export default {
  IMAGE: {
    code: 1,
    name: '图片',
  },
  VIDEO: {
    code: 2,
    name: '视频',
  },
};
